var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "113.5%",
    height: "113.2%",
    x: "-6.8%",
    y: "-6.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M76.333 16.917L58.833.875a.705.705 0 0 0-1.02 0l-17.5 16.042a.705.705 0 0 0 0 1.02.705.705 0 0 0 1.02 0l3.209-2.916v16.916c0 1.167 1.02 2.188 2.187 2.188h23.334c1.166 0 2.187-1.02 2.187-2.188V15.021l3.208 2.916c.146.146.292.146.438.146.146 0 .437-.145.583-.291.146-.146.146-.584-.146-.875zm-11.52 15.895h-5.834V22.605h5.834v10.209zm5.979-18.958v18.23c0 .437-.292.728-.73.728h-3.645V22.605c0-.875-.584-1.458-1.459-1.458h-5.833c-.875 0-1.458.583-1.458 1.458v10.209H46.729c-.437 0-.729-.292-.729-.73V13.854L58.396 2.48l12.396 11.375zm-17.646 7.292h-2.917c-.875 0-1.458.583-1.458 1.458v2.917c0 .875.583 1.458 1.458 1.458h2.917c.875 0 1.458-.583 1.458-1.458v-2.917c0-.875-.583-1.458-1.458-1.458zm0 4.375h-2.917v-2.917h2.917v2.917z",
    filter: "url(#a)",
    opacity: 0.7,
    transform: "translate(-30 6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.ba3a10de498d3ef800b4dab3099ca775.svg";
export { ForwardRef as ReactComponent };